import { HttpClient, HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  OccEndpointsService,
  ProductSearchPage,
  SearchConfig,
  TranslationService
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { UigExportProductSearchService } from '../uig-product/uig-product-list/container/uig-export-product-search.service';
import { UigExportColumns } from './uig-export-products.models';

@Injectable({
  providedIn: 'root',
})
export class UigExportProductsService {

  exportColumns: string[] = Object.values(UigExportColumns).filter(
    (value) => typeof value === 'string'
  ) as string[];

  selectedExportColumns: string[];

  constructor(
    private httpClient: HttpClient,
    private endpoints: OccEndpointsService,
    private translation: TranslationService,
    private messageService: GlobalMessageService,
    private uigExportProductSearchService: UigExportProductSearchService
  ) { }


  public setSelectedExportColumns(selection: string[]) {
    this.selectedExportColumns = selection;
  }

  public filterColumnList(columns: string[]): string[] {
    let columnList: string[] = Object.values(columns).filter(
      (value) => value.length > 0
    ) as string[];
    return columnList;
  }

  exportProductListWithSelectedExportColumns(
    format: string,
    query: string,
  ) {
    this.translation
    .translate('uigexport.info.download')
    .pipe(take(1))
    .subscribe((message) => {
      this.messageService.add(message, GlobalMessageType.MSG_TYPE_INFO);
    });

    let searchConfig: SearchConfig = { pageSize: 10000, currentPage: 0, sort: '' };
    query = new HttpUrlEncodingCodec().decodeValue(query).replace(/\+/g, ' ')
    this.uigExportProductSearchService.productSearch(query, searchConfig);

    this.uigExportProductSearchService.getLoading().pipe(
      filter((loading) => loading === false),
      map((loading) => {
        const searchResult: ProductSearchPage = this.uigExportProductSearchService.getResult();
        let products = searchResult.products;

        if (products.length > 0) {
          const productCodes = products.map(product => { return product.code });

          this.exportProductList(format, this.selectedExportColumns, productCodes);
        }
      }),
    )
      .subscribe();
  }

  exportProductList(
    format: string, exportColumnList: string[], exportProductCodesList: string[]
  ) {
    this.downLoadProductList(format, this.filterColumnList(exportColumnList), exportProductCodesList)
      .pipe(
        tap(
          (data) => {
            this.translation
              .translate('uigexport.fileName')
              .pipe(take(1))
              .subscribe((fileName) => {
                var a = document.createElement('a');
                a.setAttribute('download', fileName + '.' + format.toLowerCase());
                a.href = URL.createObjectURL(data);
                a.click();
              });
          },
          () => {
            this.translation
              .translate('uigexport.info.errorExportProducts')
              .pipe(take(1))
              .subscribe((message) => {
                this.messageService.add(
                  message,
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              });
          }
        )
      )
      .subscribe((res) => { });
  }

  downLoadProductList(
    format: string, exportColumnList: string[], exportProductCodesList: string[]): Observable<Blob> {
    const params = {
      'columns': exportColumnList,
      'format': format
    };

    const url = this.endpoints.buildUrl('exportProductList', {queryParams: params});
    return this.httpClient.post(url, exportProductCodesList, { observe: 'body', responseType: 'blob' });
  }

}
